/* global attachEvent */

// *******************************************************************************
// 1.0 - Close Modal
// *******************************************************************************

attachEvent('.modal__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.modal');
  parentEle.classList.remove('is-open-modal');
  ev.preventDefault();
});

// *******************************************************************************
// 2.0 - Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.modal').forEach((el) => {
      el.classList.remove('is-open-modal');
    });
  }
});

// *******************************************************************************
// 3.0 - Open modal on page load if in URL query
// *******************************************************************************

window.addEventListener('DOMContentLoaded', (() => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.get('modal')) {
    document.querySelectorAll('.modal').forEach((el) => {
      el.classList.add('is-open-modal');
    });
  }
}));
